/* stylelint-disable max-nesting-depth, selector-max-compound-selectors, selector-no-qualifying-type */
@use "../../sass/variables/colors";
@use "../../sass/variables/grid";
@use "../../sass/variables/typography";
@use "../../sass/mixins/font-family";

.ux-comparison-table {
  position: relative;

  &--content {
    th.first {
      display: none;
    }

    .list-styled {
      margin: 0;
    }

    thead tr {
      align-items: center;
    }

    .cat {
      background-color: colors.$color-blue-highlight-6;
    }

    @media only screen and (max-width: 550px) {
      td {
        padding: 15px !important;
        width: 250px;
      }
    }
  }

  @media only screen and (max-width: 550px) {
    .sub-cat {
      display: flex;
    }
  }

  &--data {
    .sub-cat {
      flex-wrap: wrap;

      .first {
        background: #fff;
        flex: 0 0 100%;
        left: 1px;
        pointer-events: none;
        position: absolute;
        width: calc(100% - 2px);
        @media only screen and (min-width: 550px) {
          border-right: 1px solid colors.$color-gray-border-dark;
          left: 0;
          pointer-events: all;
          position: relative;
          width: auto;
        }
      }

      td:not(.first) {
        flex: 1;
        margin-top: 60px;
        padding: 26px 30px;

        + td {
          border-left: 1px solid colors.$color-gray-border;
        }
      }
    }

    .cat {
      background-color: colors.$color-blue-highlight-6 !important;
      border-bottom: 1px solid colors.$color-gray-border;
      position: relative;
      @media only screen and (max-width: 550px) {
        display: flex;
        width: auto;
      }

      ux-icon[name="chevron-right"] {
        left: calc(100vw - 40px - 2rem);
        position: absolute;
        top: 50%;
      }

      &.opened {
        .first {
          ux-icon[name="chevron-right"] {
            left: calc(100vw - 40px - 2rem);
            position: absolute;
            top: 50%;
            transform: translateY(-50%) translateY(6px) rotate(-90deg);
          }
        }
      }

      .first {
        border: 0;
        left: 0;
        position: sticky;

        ux-icon[name="chevron-right"] {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%) translateY(-5px) rotate(90deg);
        }

        @media only screen and (min-width: 550px) {
          text-align: center;

          ux-icon {
            display: none;
          }

          span {
            position: static;
          }
        }
      }
    }

    .container {
      overflow: scroll;
      @media only screen and (min-width: grid.$tablet) {
        overflow: initial;
      }
    }

    tbody tr {
      background-color: colors.$color-white;
      display: flex;
      flex-basis: 0;
      flex-grow: 1;

      @media only screen and (min-width: 550px) {
        display: table-row;
      }

      th:first-child,
      td:first-child {
        border-left: 0 solid;
      }

      th:last-child,
      td:last-child {
        border-right: 0 solid;
      }
    }

    @media only screen and (max-width: 550px) {
      td,
      th {
        white-space: nowrap;
      }
    }
  }

  .container {
    border-left: 1px solid colors.$color-gray-border;
    border-right: 1px solid colors.$color-gray-border;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
    margin: 0 auto;
    width: 100%;
    @media only screen and (min-width: 550px) {
      table-layout: fixed;
    }
  }

  td,
  th {
    border-bottom: 1px solid colors.$color-gray-border;
    min-height: 60px;
    padding: 16px 30px;
    vertical-align: middle;
    white-space: normal;

    + th {
      border-left: 1px solid colors.$color-gray-border;
    }
  }

  @media only screen and (max-width: 550px) {
    th.first {
      display: none;
    }

    th {
      flex: 1;
    }

    tr[data-info] {
      display: none;

      &.opened {
        display: flex;
      }
    }

    tr[data-target] {
      * {
        pointer-events: none;
      }

      &.opened {
        ux-icon {
          transform: translateY(-50%) translateY(5px) rotate(270deg);
        }
      }
    }
  }

  &--fixed-column-width {
    td {
      padding: 15px !important;
      width: 250px;
    }

    .sub-cat {
      display: flex;
    }

    th.first {
      display: none;
    }

    th {
      flex: 1;
    }

    tr[data-info] {
      display: none;

      &.opened {
        display: flex;
      }
    }

    table {
      table-layout: auto;
    }
  }

  .ux-comparison-table---td-visible {
    display: block;
  }

  &--nowrap {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__icon-text {
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
  }

  &__status-icon {
    font-size: 23px;
    margin-right: 8px;
  }

  th {
    @include font-family.font(bold);
    background-color: colors.$color-blue-5;
    font-size: typography.$size-text-small;
    text-transform: uppercase;
  }

  thead tr {
    background-color: colors.$color-blue-5;
    display: flex;
    @media only screen and (min-width: 550px) {
      display: table-row;
    }

    th {
      border-right: 1px solid colors.$color-gray-border-dark;

      &:last-child {
        border-right: 0;
      }
    }
  }

  &--heading-cell {
    @include font-family.font(bold);
    background-color: rgba(195, 207, 214, 0.5);
    font-size: typography.$size-text-small;
    text-align: center;
    text-transform: uppercase;
    @media only screen and (max-width: 550px) {
      text-align: start;
    }
  }

  &__inner {
    height: auto;
    overflow-x: auto;

    &::before,
    &::after {
      content: "";
      height: calc(100% + 1px);
      opacity: 0;
      pointer-events: none;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      transition: opacity 0.5s ease;
      width: 50px;
      z-index: 1;
    }

    &::before {
      background: linear-gradient(to left, rgba(255, 255, 255, 0) 0, rgba(0, 0, 0, 0.2) 100%);
    }

    &::after {
      background: linear-gradient(to right, rgba(255, 255, 255, 0.1) 0, #fff 100%);
      right: 0;
    }
  }

  &--non-fixed-column &__inner::before {
    background: linear-gradient(to left, rgba(255, 255, 255, 0) 0, #fff 100%);
  }

  &__fixed-link {
    display: none;
    padding: 9px 2px 9px 8px;
    position: absolute;
    right: -3px;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &--is-fixed {
    table {
      min-width: auto;
    }

    .ux-table__fixed-link {
      display: inline-block;
    }
  }
}
/* stylelint-enable max-nesting-depth, selector-max-compound-selectors, selector-no-qualifying-type */
